console.log(`
U     U   N     N   RRRRRR   U     U   L         Y     Y
U     U   NN    N   R    R   U     U   L          Y   Y 
U     U   N N   N   RRRRRR   U     U   L           Y Y  
U     U   N  N  N   R  R     U     U   L            Y   
U     U   N   N N   R   R    U     U   L            Y   
 UUUUU    N     N   R    R    UUUUU   LLLLLLL       Y   
`);
console.log(`Developed by Ayuba`, "contact me: preyealexander731@gmail.com");

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      button: this.querySelector(".disclosure__button"),
      panel: this.querySelector("ul"),
      closeButton: this.querySelector(".CountryListCloseBtn"),
      cartOverlay: document.querySelector(".blur-overlay"),
    };
    this.elements.button.addEventListener(
      "click",
      this.openSelector.bind(this)
    );
    this.elements.button.addEventListener(
      "focusout",
      this.closeSelector.bind(this)
    );
    this.elements.closeButton.addEventListener(
      "click",
      this.closeSelector.bind(this)
    );
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    // this.elements.panel.setAttribute("hidden", true);
    this.elements.panel.classList.toggle("slide-in");
    this.elements.cartOverlay.classList.toggle("show_blur");
    document.getElementsByTagName("body")[0].style.overflow = "auto";
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    // this.elements.panel.toggleAttribute("hidden");
    this.elements.panel.classList.toggle("slide-in");
    this.elements.button.setAttribute(
      "aria-expanded",
      (
        this.elements.button.getAttribute("aria-expanded") === "false"
      ).toString()
    );
    this.elements.cartOverlay.classList.toggle("show_blur");
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
  }

  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define("localization-form", LocalizationForm);
